export default __webpack_public_path__ + "static/media/rose-2.5cd402d6.jpg";